import image from "../src/assets/home1.png"
import image1 from "../src/assets/home2.jpg"
import image2 from "../src/assets/home3.jpg"
import image3 from "../src/assets/home4.jpg"

import u1 from "../src/assets/u1.jpg"
import u2 from "../src/assets/u2.jpg"
import u3 from "../src/assets/u3.jpg"
import u4 from "../src/assets/u4.jpg"
import u5 from "../src/assets/u5.jpg"
import u6 from "../src/assets/u6.png"
import u7 from "../src/assets/u7.jpg"

import slide1 from "../src/assets/slide1.png"
import slide3 from "../src/assets/slide3.jpg"

import rec1 from "../src/assets/rec1.jpg"
import rec2 from "../src/assets/rec2.jpg"
import rec3 from "../src/assets/rec3.jpg"
import rec4 from "../src/assets/rec4.jpg"
import videopride from "../src/assets/video/pride.mp4"

export const homeData = [
  {
    id: 1,
    name: "Pride & Prejudice",
    rating: 7.8,
    time: "2hr : 9mins",
    desc: "Pride and Prejudice by Jane Austen.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Romantic ",
    tags: "Romantic, Drama",
    cover: image,
    video: videopride,
    date: "16-Sept-2005",
  },
  {
    id: 2,
    name: "skull island",
    rating: 4.6,
    time: "2hr : 22mins",
    desc: "The island, like its inhabitants, is wholly fictional. Kong's island home in the Pacific makes its first appearance, along with Kong himself, in the 1933 film King Kong. ",
    starring: "Brenda Chapman, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Animation,Family",
    cover: image1,
    video: "../video/video2.mp4",
    date: "10-JUL-2021",
  },
  {
    id: 3,
    name: "Pirates Sea",
    rating: 4.8,
    time: "2hr : 22mins",
    desc: "Piracy is an act of robbery or criminal violence by ship or boat-borne attackers upon another ship or a coastal area, typically with the goal of stealing cargo and other valuable items or properties. ",
    starring: "James Chinlund, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Action ",
    cover: image2,
    video: "../video/video3.mp4",
    date: "20-FEB-2010",
  },
  {
    id: 4,
    name: "Sand Dust",
    rating: 4.9,
    time: "2hr : 22mins",
    desc: "Sand and dust storms (SDS), also known as sirocco, haboob, yellow dust, white storms, and the harmattan, are a natural phenomenon linked with land and water management and climate change.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Action",
    tags: "Action, Adventures, Horror",
    cover: image3,
    video: "../video/video4.mp4",
    date: "12-Aug-2015",
  },
]
export const upcome = [
  {
    id: 1,
    cover: u1,
    name: "My office Boss",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: u2,
    name: "Shadowe",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: u3,
    name: "Another Danger",
    time: "2hr : 38mins",
  },
  {
    id: 4,
    cover: u4,
    name: "One Man Army",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: u5,
    name: "Jumbo Queen",
    time: "2hr : 38mins",
  },
]
export const latest = [
  {
    id: 1,
    cover: u6,
    name: "King of Jungle",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: u7,
    name: "The illusion",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: u1,
    name: "Latest Movie",
    time: "2hr : 38mins",
  },
  {
    id: 4,
    cover: u5,
    name: "Latest two",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: u4,
    name: "Latest Three",
    time: "2hr : 38mins",
  },
]

export const trending = [
  {
    id: 1,
    name: "The Dinosaur",
    rating: 4.7,
    time: "2hr : 22mins",
    desc: "Sand and dust storms (SDS), also known as sirocco, haboob, yellow dust, white storms, and the harmattan, are a natural phenomenon linked with land and water management and climate change.",
    starring: "Karen Gilchrist, James Earl Jones",
    genres: "Action",
    tags: "Action, Adventures, Horror",
    cover: slide1,
    date: "20-Jan-1997",
  },
  {
    id: 2,
    name: "The Great Emperor",
    rating: 4.6,
    time: "2hr : 22mins",
    desc: "The island, like its inhabitants, is wholly fictional. Kong's island home in the Pacific makes its first appearance, along with Kong himself, in the 1933 film King Kong. ",
    starring: "Brenda Chapman, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Animation,Family",
    cover: u5,
    date: "10-JUL-2021",
  },
  {
    id: 3,
    name: "Jumbo Queen",
    rating: 4.8,
    time: "2hr : 22mins",
    desc: "Piracy is an act of robbery or criminal violence by ship or boat-borne attackers upon another ship or a coastal area, typically with the goal of stealing cargo and other valuable items or properties. ",
    starring: "James Chinlund, Jeff Nathanson",
    genres: "Adventures",
    tags: "Adventures,Action ",
    cover: slide3,
    date: "20-FEB-2010",
  },
]
export const recommended = [
  {
    id: 4,
    cover: rec1,
    name: "One Man Army",
    time: "2hr : 38mins",
  },
  {
    id: 5,
    cover: rec2,
    name: "Jumbo Queen",
    time: "2hr : 38mins",
  },
  {
    id: 1,
    cover: rec3,
    name: "My office Boss",
    time: "2hr : 38mins",
  },
  {
    id: 2,
    cover: rec4,
    name: "Shadowe",
    time: "2hr : 38mins",
  },
  {
    id: 3,
    cover: u3,
    name: "Another Danger",
    time: "2hr : 38mins",
  },
]